import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import '../styles/Page.css'

import Navbar from "../components/Navbar";
import CourseFilter from "../components/CourseFilter";
import IndividualGoal, { IndividualGoalType } from "../components/IndividualGoal";
import IndividualProgressDialog from "../components/IndividualProgressDialog";

import AddStudentDialog from "../components/AddStudentDialog";
import GoalSkeleton from "../components/GoalSkeleton";

import { useFetch } from "../hooks/useFetch";
import { useCookies } from "react-cookie";
import EditStudentInfoDialog from "../components/EditStudentInfoDialog";
import { StudentCardProps2 } from "../components/IndividualStudentCard";
import EditDueDateDialog from "../components/EditDueDateDialog";
import DeleteProgressesDialog from "../components/DeleteProgressesDialog";
import GoalNotFound from "../components/GoalNotFound";
import SearchNotFound from "../components/SearchNotFound";
import FilterGoalButton from "../components/FilterGoalButton";
import ImportExcelDialog from "../components/ImportExcelDialog";
import GoalDetail from "../components/GoalDetail";
import CreateNewSemesterDialog from "../components/CreateNewSemesterDialog";
import AddNewCommonGoalAndStudents from "../components/AddNewCommonGoalAndStudents";

export default function Scholarship() {

  const { progressID, courseID, semesterID } = useParams()

  const [cookies, setCookie] = useCookies(['user'])

  let navigate = useNavigate();

  useEffect(() => {
    if (!cookies?.user?.token) {
      navigate(`/`)
    }
  }, [])

  const [semesterId, setSemesterId] = useState<number>(Number(semesterID || 0) || Number(localStorage.getItem(`semester_selected`)))
  const [courseId, setCourseId] = useState<number>(Number(courseID || 0) || Number(localStorage.getItem(`course_id_selected`)))

  const [scholarships, setScholarships] = useState([])
  const [scholarshipsForFilter, setScholarshipsForFilter] = useState<IndividualGoalType[]>([]) // Scholarships for filter
  const [scholarshipsForSearch, setScholarshipsForSearch] = useState<IndividualGoalType[]>([])
  const [courseStudentList, setCourseStudentList] = useState<StudentCardProps2[]>([])

  const [numberOfStudentInScholarship, setNumberOfStudentInScholarship] = useState<{ [key: number]: number }>({})

  const [openCreateSemester, setOpenCreateSemester] = useState(false)
  const [openAddNewStudents, setOpenAddNewStudents] = useState(false)
  const [openGoalDetail, setOpenGoalDetail] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [openEditInfo, setOpenEditInfo] = useState(false)
  const [openAddStudentDialog, setOpenAddStudentDialog] = useState(false)
  const [openImportExcelDialog, setOpenImportExcelDialog] = useState(false)
  const [openEditDueDate, setOpenEditDueDate] = useState(false);
  const [openDeleteProgresses, setOpenDeleteProgresses] = useState(false)

  const [goalIdTarget, setGoalIdTarget] = useState(-1)
  const [studentTargetList, setStudentTargetList] = useState<StudentCardProps2[]>([])

  const [sortKey, setSortKey] = useState('deadline')
  const [search, setSearch] = useState("")

  const { data: getScholarshipsData, error: getScholarshipsError, loading: getScholarshipsLoading } = useFetch({
    url: `/Scholarships`,
    method: "GET",
    headers: {
      'Authorization': `Bearer ${cookies?.user?.token}`
    }
  })

  const { data: getStudentsData, error: getStudentsError, loading: getStudentsLoading } = useFetch({
    url: `/Students?curriculumId=${courseId}&semesterId=${semesterId}`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${cookies?.user?.token}`
    }
  }, courseId, semesterId)

  useEffect(() => {
    if (getScholarshipsData) {
      setScholarships(getScholarshipsData)
    }
  }, [getScholarshipsData])

  useEffect(() => {
    setCourseStudentList(getStudentsData)
  }, [getStudentsData])

  const handleGoalIdTarget = (goalID: number) => {
    setGoalIdTarget(goalID)
  }

  const handleStudentTargetList = (studentList: StudentCardProps2[]) => {
    setStudentTargetList(studentList)
  }

  useEffect(() => {
    setOpenDialog(progressID !== undefined)
  }, [])

  const handleClickClose = (e: any) => {
    setOpenDialog(false)
    navigate(`/scholarship/`)
  }

  const clearTarget = () => {
    setGoalIdTarget(-1)
    setStudentTargetList([])
  }

  const handleClickCloseCreateSemester = () => {
    setOpenCreateSemester(false)
  }

  const handleClickCloseAddNewStudents = () => {
    setOpenAddNewStudents(false)
  }

  const handleClickCloseGoalDetail = () => {
    setOpenGoalDetail(false)
    clearTarget()
  }

  const handleClickCloseAddStudent = () => {
    setOpenAddStudentDialog(false)
    clearTarget()
  }

  const handleClickCloseImportExcel = () => {
    setOpenImportExcelDialog(false)
    clearTarget()
  }

  const handleClickCloseEditDueDate = () => {
    setOpenEditDueDate(false)
    clearTarget()
  }

  const handleClickCloseDeleteProgresses = () => {
    setOpenDeleteProgresses(false)
    clearTarget()
  }

  const handleBackDropClick = (e: any) => {
    if (e.target.className === "ProgressDialog") {

    }
  }

  const handleSort = (e: any) => {
    setSortKey(e.target.value)
  }

  useMemo(() => {
    if (search !== "") {
      setScholarshipsForSearch(
        getScholarshipsData.filter((goal: IndividualGoalType) => {
          return numberOfStudentInScholarship[goal.id] > 0
        })
      )
    } else {
      setScholarshipsForSearch([])
    }
  }, [numberOfStudentInScholarship])

  const scrollHorizontal = (e: any) => {
    const scroll = e.deltaY
    const scrollContainer = document.getElementById("scroll-container")

    if (scrollContainer && (e.target.className.includes("Page-goal-list") || e.target.className.includes("Goal-goal"))) {
      if (scroll > 0) {
        scrollContainer.scrollLeft += 294
      } else if (scroll < 0) {
        scrollContainer.scrollLeft -= 294
      }
    }
  }

  const searchScrollHorizontal = (e: any) => {
    const scroll = e.deltaY
    const scrollContainer = document.getElementById("search-scroll-container")

    if (scrollContainer && (e.target.className.includes("Page-goal-list") || e.target.className.includes("common") || e.target.className.includes("Goal-goal"))) {
      if (scroll > 0) {
        scrollContainer.scrollLeft += 294
      } else if (scroll < 0) {
        scrollContainer.scrollLeft -= 294
      }
    }
  }

  return (
    <div className="Page">
      {
        openCreateSemester &&
        <CreateNewSemesterDialog  handleClickClose={handleClickCloseCreateSemester}/>
      }
      {
        openAddNewStudents &&
        <AddNewCommonGoalAndStudents semesterId={semesterId} courseId={courseId} handleClickClose={handleClickCloseAddNewStudents} isStudent/>
      }
      {
        openDeleteProgresses &&
        <DeleteProgressesDialog goalId={goalIdTarget} goalList={scholarships} studentList={studentTargetList} setStudentList={setStudentTargetList} handleClickClose={handleClickCloseDeleteProgresses} isScholarship={true} />
      }
      {
        openEditDueDate &&
        <EditDueDateDialog goalId={goalIdTarget} goalList={scholarships} studentList={studentTargetList} setStudentList={setStudentTargetList} handleClickClose={handleClickCloseEditDueDate} isScholarship={true} />
      }
      {
        openEditInfo &&
        <EditStudentInfoDialog setOpenEditInfo={setOpenEditInfo} />
      }
      {
        openGoalDetail &&
        <GoalDetail goalIdTarget={goalIdTarget} individualGoalList={scholarships} handleClickClose={handleClickCloseGoalDetail}/>
      }
      {
        openDialog &&
        <IndividualProgressDialog
          id={Number(progressID)}
          handleClickClose={handleClickClose}
          handleBackDropClick={handleBackDropClick}
          individualGoalList={scholarships}
          isScholarship={true}
          openEditInfo={openEditInfo}
          setOpenEditInfo={setOpenEditInfo}
        />
      }
      {
        openAddStudentDialog &&
        <AddStudentDialog
          goalIdTarget={goalIdTarget}
          goalList={scholarships}
          courseId={courseId}
          semesterId={semesterId}
          handleClickClose={handleClickCloseAddStudent}
          handleBackDropClick={handleBackDropClick}
          isScholarship={true}
        />
      }
      {
        openImportExcelDialog &&
        <ImportExcelDialog
          goalIdTarget={goalIdTarget}
          goalList={scholarships}
          courseId={courseId}
          semesterId={semesterId}
          handleClickClose={handleClickCloseImportExcel}
          isScholarship={true}
        />
      }
      <Navbar />
      <CourseFilter
        semesterId={semesterId}
        courseId={courseId}
        setSemesterId={setSemesterId}
        setCourseId={setCourseId}
        setSearch={setSearch}
        openCreateSemester={openCreateSemester}
        setOpenCreateSemester={setOpenCreateSemester}
        setOpenAddNewStudents={setOpenAddNewStudents}
      />
      <div className="Page-actions-bar">
        <div className="Page-goal-switch-container flex gap-dot5">
          <button
            className={"Page-goal-switch active-switch"}
          >
            Scholarships
          </button>
        </div>

        <div className="flex-container gap-dot75">

          <FilterGoalButton goalList={scholarships} filterGoalList={scholarshipsForFilter} setFilterGoalList={setScholarshipsForFilter} isScholarship={true} />

          <div className="flex gap-dot25">
            <label htmlFor="sortby" className="visually-hidden">Sort by</label>
            <select name="sortby" id="sortby" onChange={handleSort} className="Page-sortby-selector">
              <option value="deadline">Due Date</option>
              <option value="studentId">Student ID</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>
      </div>
      {(getScholarshipsLoading) ? <GoalSkeleton /> :
        <>
          {scholarships &&
            <div className="Page-goal-list" onWheel={scrollHorizontal} id="scroll-container" style={{ display: search !== "" ? "none" : "flex" }}>
              {
                (scholarshipsForFilter.length !== 0 && scholarshipsForFilter.length < scholarships.length) ? (
                  scholarshipsForFilter.map((props: any) => (
                    <IndividualGoal
                      key={props.id}
                      id={props.id}
                      no={props.no}
                      name={props.name}
                      description={props.description}
                      semesterId={semesterId}
                      courseId={courseId}
                      openDialog={openDialog}
                      setOpenDialog={setOpenDialog}
                      openAddStudentDialog={openAddStudentDialog}
                      setOpenAddStudentDialog={setOpenAddStudentDialog}
                      openImportExcelDialog={openImportExcelDialog}
                      setOpenImportExcelDialog={setOpenImportExcelDialog}
                      openEditDueDateDialog={openEditDueDate}
                      setOpenEditDueDateDialog={setOpenEditDueDate}
                      openDeleteProgressesDialog={openDeleteProgresses}
                      setOpenDeleteProgressesDialog={setOpenDeleteProgresses}
                      openGoalDetail={openGoalDetail}
                      setOpenGoalDetail={setOpenGoalDetail}
                      handleGoalIdTarget={handleGoalIdTarget}
                      handleStudentTargetList={handleStudentTargetList}
                      sortKey={sortKey}
                      search={search}
                      beginPath={`/scholarship/${courseId}/${semesterId}/individual_goal`}
                      isScholarship={true}
                      courseStudentList={courseStudentList}
                      setNumberOfStudentInIndividualGoal={setNumberOfStudentInScholarship}
                    />
                  ))
                ) : (
                  scholarships.map((props: any) => (
                    <IndividualGoal
                      key={props.id}
                      id={props.id}
                      no={props.no}
                      name={props.name}
                      description={props.description}
                      semesterId={semesterId}
                      courseId={courseId}
                      openDialog={openDialog}
                      setOpenDialog={setOpenDialog}
                      openAddStudentDialog={openAddStudentDialog}
                      setOpenAddStudentDialog={setOpenAddStudentDialog}
                      openImportExcelDialog={openImportExcelDialog}
                      setOpenImportExcelDialog={setOpenImportExcelDialog}
                      openEditDueDateDialog={openEditDueDate}
                      setOpenEditDueDateDialog={setOpenEditDueDate}
                      openDeleteProgressesDialog={openDeleteProgresses}
                      setOpenDeleteProgressesDialog={setOpenDeleteProgresses}
                      openGoalDetail={openGoalDetail}
                      setOpenGoalDetail={setOpenGoalDetail}
                      handleGoalIdTarget={handleGoalIdTarget}
                      handleStudentTargetList={handleStudentTargetList}
                      sortKey={sortKey}
                      search={search}
                      beginPath={`/scholarship/${courseId}/${semesterId}/individual_goal`}
                      isScholarship={true}
                      courseStudentList={courseStudentList}
                      setNumberOfStudentInIndividualGoal={setNumberOfStudentInScholarship}
                    />
                  ))
                )
              }
            </div>
          }
          {scholarshipsForSearch.length !== 0 && search !== "" &&
            <div className="Page-goal-list" onWheel={searchScrollHorizontal} id="search-scroll-container">
              {scholarshipsForSearch.map((props: any) => (
                <IndividualGoal
                  key={props.id}
                  id={props.id}
                  no={props.no}
                  name={props.name}
                  description={props.description}
                  semesterId={semesterId}
                  courseId={courseId}
                  openDialog={openDialog}
                  setOpenDialog={setOpenDialog}
                  openAddStudentDialog={openAddStudentDialog}
                  setOpenAddStudentDialog={setOpenAddStudentDialog}
                  openImportExcelDialog={openImportExcelDialog}
                  setOpenImportExcelDialog={setOpenImportExcelDialog}
                  openEditDueDateDialog={openEditDueDate}
                  setOpenEditDueDateDialog={setOpenEditDueDate}
                  openDeleteProgressesDialog={openDeleteProgresses}
                  setOpenDeleteProgressesDialog={setOpenDeleteProgresses}
                  openGoalDetail={openGoalDetail}
                  setOpenGoalDetail={setOpenGoalDetail}
                  handleGoalIdTarget={handleGoalIdTarget}
                  handleStudentTargetList={handleStudentTargetList}
                  sortKey={sortKey}
                  search={search}
                  beginPath={`/scholarship/${courseId}/${semesterId}/individual_goal`}
                  isScholarship={true}
                  courseStudentList={courseStudentList}
                />
              ))}
            </div>
          }
          {search === "" && (scholarships != null && scholarships.length === 0) &&
            <div className="Page-goal-list">
              <GoalNotFound />
            </div>
          }
          {search !== "" && (scholarshipsForSearch.length === 0) &&
            <div className="Page-goal-list">
              <SearchNotFound />
            </div>
          }
        </>
      }
    </div >
  );
}